import { watch } from "vue";
import { useDateStore } from "../stores/datestore";
import { parseEvent } from "../libs/parsers";
import { useEventStore } from "../stores/EventStore";
import { useAppointmentStore } from "../stores/appointmentsStore";
import { storeToRefs } from "pinia";
import axios, { Axios } from "axios";
import { getDateWithStartTime, getDateWithEndTime } from "../libs/date";

export function useEvents() {
  let events = useEventStore();
  const appointmentStore = useAppointmentStore();
  const dateStore = useDateStore();
  let { selectedDate } = storeToRefs(dateStore);
  let { currentRange } = storeToRefs(appointmentStore);

  watch(
    currentRange,
    () => {
      events.reset();
      appointmentStore.events_loaded = false;
      let startat = getDateWithStartTime(currentRange);
      let endat = getDateWithEndTime(currentRange);

      axios({
        method: "get",
        url: "/api/bookings",
        params: {
          start: startat,
          end: endat,
        },
      })
        .then((response) => {
          events.addActiveRange(dateStore.getISODate);
          for (let event in response.data) {
            events.addEvent(parseEvent(response.data[event]));
          }
          appointmentStore.events_loaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    { deep: true, immediate: true }
  );

  return { events, selectedDate };
}

export function useStylists() {
  const dateStore = useDateStore();
  const appointmentStore = useAppointmentStore();

  let { selectedDate } = storeToRefs(dateStore);
  watch(
    selectedDate,
    () => {
      axios({
        method: "get",
        url: "/api/stylists",
      })
        .then((response) => {
          response.data.forEach((element) => {
            appointmentStore.addStylist(element);
          });
        })
        .catch((error) => console.log(error));
    },
    { immediate: true }
  );
}
